module.exports = "<sa-menu></sa-menu>\r\n<p>\r\n  Home Works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 1193
// module chunks = 0